/**
 * Route definitions for the admin (management) app.
 *
 * These routes are served under `/Manage/` but defined without the
 * prefix — the router's `setBasePath('/Manage')` transparently
 * prepends it for pushState and strips it for route matching.
 */

import Dashboard from '../pageComponents/Dashboard.svelte';
import Settings from '../pageComponents/Settings.svelte';
import Users from '../pageComponents/Users.svelte';
import UserEdit from '../pageComponents/users/UserEdit.svelte';
import UserImport from '../pageComponents/users/UserImport.svelte';
import Applications from '../pageComponents/Applications.svelte';
import ApplicationEdit from '../pageComponents/applications/ApplicationEdit.svelte';
import Roles from '../pageComponents/Roles.svelte';
import Licenses from '../pageComponents/licenses/Licenses.svelte';
import LicenseDetail from '../pageComponents/licenses/LicenseDetail.svelte';
import Newsletters from '../pageComponents/newsletters/Newsletters.svelte';
import NewsletterEditor from '../pageComponents/newsletters/NewsletterEditor.svelte';
import NewsletterSend from '../pageComponents/newsletters/NewsletterSend.svelte';
import Support from '../pageComponents/support/Support.svelte';
import SupportNewTicket from '../pageComponents/support/SupportNewTicket.svelte';
import SupportTicketView from '../pageComponents/support/SupportTicketView.svelte';
import SupportDesk from '../pageComponents/support/SupportDesk.svelte';
import SupportDeskNewTicket from '../pageComponents/support/SupportDeskNewTicket.svelte';
import SupportDeskTicketView from '../pageComponents/support/SupportDeskTicketView.svelte';
import SupportReplyTemplates from '../pageComponents/support/SupportReplyTemplates.svelte';
import Handle404 from '../pageComponents/404.svelte';

/** Admin route map — URL patterns to page components. */
export default {
	'/': Dashboard,
	/* The licence page's three sections are three real routes onto the one
	   component, which reads the first path segment to decide which panel opens.
	   They are one page because a licence is why you may have a build, the build
	   is what people came for and the documentation is what you read afterwards —
	   but each is a place the sidebar can name and a reader can bookmark, which a
	   query parameter is not. */
	'/Licenses': Licenses,
	'/Licenses/:appUUID': Licenses,
	'/Licenses/:appUUID/:licenseUUID': LicenseDetail,
	'/Downloads': Licenses,
	'/Downloads/:appUUID': Licenses,
	'/Documentation': Licenses,
	'/Documentation/:appUUID': Licenses,
	/* Support: the customer side first, then the agent desk under `/Support/Desk`.
	   Static routes precede the parameterised ones beside them, since the router
	   takes the first pattern that matches — `/Support/New` would otherwise never
	   be reached past a `/Support/:anything`, and the same holds for `Desk/New`. */
	'/Support': Support,
	'/Support/New': SupportNewTicket,
	'/Support/New/:appUUID': SupportNewTicket,
	'/Support/Tickets/:ticketKey': SupportTicketView,
	'/Support/Desk': SupportDesk,
	'/Support/Desk/New': SupportDeskNewTicket,
	'/Support/Desk/Templates': SupportReplyTemplates,
	'/Support/Desk/Tickets/:ticketKey': SupportDeskTicketView,
	'/Settings': Settings,
	'/Settings/*': Settings,
	'/Users': Users,
	'/Users/Import': UserImport,
	'/Users/:id': UserEdit,
	'/Applications': Applications,
	'/Applications/:id': ApplicationEdit,
	'/Roles': Roles,
	'/Newsletters': Newsletters,
	'/Newsletters/new': NewsletterEditor,
	'/Newsletters/:id/edit': NewsletterEditor,
	'/Newsletters/:id/send': NewsletterSend,

	// Catch-all
	'*': Handle404
};
